<div class="mb-2 flex items-center gap-1.5">
  <dojo-text-input
    [formCtrl]="emojiCtrl"
    [size]="'xs'"
    [readOnly]="true"
    [placeholder]="'examdojo.tags.no_emoji_selected' | transloco"
    class="flex-1"
  >
    @if (selectedEmoji()) {
      <button dojoInputSuffix mat-icon-button type="button" (click)="clearSelection()">
        <dojo-icon icon="circle-xmark" faPrefix="fas" class="text-secondary" />
      </button>
    }
  </dojo-text-input>
  <dojo-button [size]="'xs'" [customColor]="'sky'" [fill]="'outline'" (click)="selectRandomEmoji()" class="shrink-0">
    <dojo-icon [icon]="'shuffle'"></dojo-icon>
  </dojo-button>
</div>

<dojo-icon-picker
  class="tag-emoji-picker"
  [perLine]="7"
  [emojiSize]="21"
  [autoFocus]="false"
  [showPreview]="false"
  [enableSearch]="true"
  (iconSelected)="onIconSelected($event)"
/>
